import { render, staticRenderFns } from "./RoomCBTModal.vue?vue&type=template&id=0c676401&scoped=true&"
import script from "./RoomCBTModal.vue?vue&type=script&lang=js&"
export * from "./RoomCBTModal.vue?vue&type=script&lang=js&"
import style0 from "./RoomCBTModal.vue?vue&type=style&index=0&id=0c676401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c676401",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c676401')) {
      api.createRecord('0c676401', component.options)
    } else {
      api.reload('0c676401', component.options)
    }
    module.hot.accept("./RoomCBTModal.vue?vue&type=template&id=0c676401&scoped=true&", function () {
      api.rerender('0c676401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTModal.vue"
export default component.exports